export default __webpack_public_path__ + "static/singing-8a4a940f5ff91484d746a837b548843c.mp3";